module.exports = __webpack_public_path__ + "img/logo_mcdonalds_rd.323e1240.png";